import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";

export const AlterarPeriodoService = {
  async salvarAlteracao(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      `alterarperiodo`,
      postData,
    );
    if (response.error) {
      SnackBarModule(await response.message.message, "error");

      if (!response.message.message) {
        SnackBarModule(await response.message.error, "error");
      }
      return false;
    }
    SnackBarModule("Enviado com sucesso", "success");
    return true;
  },
  async salvarAlteracaoV2(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      `alterarperiodo/v2`,
      postData,
    );
    if (response.error) {
      SnackBarModule(await response.message.message, "error");

      if (!response.message.message) {
        SnackBarModule(await response.message.error, "error");
      }
      return false;
    }
    SnackBarModule("Enviado com sucesso", "success");
    return true;
  },
}